// @flow
import React from 'react';
import './SectionCurrent.scss';

type Props = {
  name: string,
  count: ?number,
  description: string,
  thumbnail: ?string,
};

const SectionCurrent = ({ name, count, description, thumbnail }: Props) => {
  return (
    <div className="SectionCurrent">
      {thumbnail && (
        <div className="thumbnail-wrapper">
          <img src={thumbnail} alt={name} className="thumbnail" />
        </div>
      )}
      <div className="content">
        <div className="title">
          {name}{' '}
          {typeof count === 'number' && (
            <span className="lighten">({count && count.toLocaleString()}개의 상품)</span>
          )}
        </div>
        <div className="description">{description}</div>
      </div>
    </div>
  );
};

export default SectionCurrent;



// WEBPACK FOOTER //
// ./src/components/sections/SectionCurrent/SectionCurrent.js